module.exports = __webpack_public_path__ + "static/media/company.1e72e801.png";